import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const getWorklistDefinitions = createAction(actionTypes.GET_WORKLIST_DEFINITIONS_REQUEST);
export const getWorklistDefinitionsSuccess = createAction(
  actionTypes.GET_WORKLIST_DEFINITIONS_SUCCESS,
);
export const getWorklistDefinitionsFailure = createAction(
  actionTypes.GET_WORKLIST_DEFINITIONS_FAILURE,
);

export const getWorklistData = createAction(actionTypes.GET_WORKLIST_DATA_REQUEST);
export const getWorklistDataSuccess = createAction(actionTypes.GET_WORKLIST_DATA_SUCCESS);
export const getWorklistDataFailure = createAction(actionTypes.GET_WORKLIST_DATA_FAILURE);

export const getWorklistDataNext = createAction(actionTypes.GET_WORKLIST_DATA_NEXT_REQUEST);
export const getWorklistDataNextSuccess = createAction(actionTypes.GET_WORKLIST_DATA_NEXT_SUCCESS);
export const getWorklistDataNextFailure = createAction(actionTypes.GET_WORKLIST_DATA_NEXT_FAILURE);

export const getWorklistViews = createAction(actionTypes.GET_WORKLIST_VIEWS_REQUEST);
export const getWorklistViewsSuccess = createAction(actionTypes.GET_WORKLIST_VIEWS_SUCCESS);
export const getWorklistViewsFailure = createAction(actionTypes.GET_WORKLIST_VIEWS_FAILURE);

export const createWorklistView = createAction(actionTypes.CREATE_WORKLIST_VIEW_REQUEST);
export const createWorklistViewSuccess = createAction(actionTypes.CREATE_WORKLIST_VIEW_SUCCESS);
export const createWorklistViewFailure = createAction(actionTypes.CREATE_WORKLIST_VIEW_FAILURE);

export const updateWorklistViews = createAction(actionTypes.UPDATE_WORKLIST_VIEWS_REQUEST);
export const updateWorklistViewsSuccess = createAction(actionTypes.UPDATE_WORKLIST_VIEWS_SUCCESS);
export const updateWorklistViewsFailure = createAction(actionTypes.UPDATE_WORKLIST_VIEWS_FAILURE);

export const updateFilters = createAction(actionTypes.UPDATE_FILTERS);
export const updateSort = createAction(actionTypes.UPDATE_WORKLIST_SORT);
export const updateView = createAction(actionTypes.UPDATE_VIEW);
export const updateDefaultExpand = createAction(actionTypes.UPDATE_DEFAULT_EXPAND);

export const clearWorklistData = createAction(actionTypes.CLEAR_WORKLIST_DATA);

export const setOpenActions = createAction(actionTypes.SET_OPEN_ACTIONS);

export const clearViews = createAction(actionTypes.CLEAR_VIEWS);
export const setCurrentWorklistId = createAction(actionTypes.SET_CURRENT_WORKLIST_ID);

export const setChildDetailParams = createAction(actionTypes.SET_CHILD_DETAIL_PARAMS);

export const setMappedColumnDefs = createAction(actionTypes.SET_MAPPED_COLUMNS);
export const setChildSelection = createAction(actionTypes.SET_CHILD_SELECTION);
export const setOpenFilterId = createAction(actionTypes.SET_OPEN_FILTER_ID);

export const getWorklistMetaDataRequest = createAction(actionTypes.GET_WORKLIST_METADATA_REQUEST);
export const getWorklistMetaDataSuccess = createAction(actionTypes.GET_WORKLIST_METADATA_SUCCESS);
export const getWorklistMetaDataFailure = createAction(actionTypes.GET_WORKLIST_METADATA_FAILURE);

export const refreshWorkgrid = createAction(actionTypes.REFRESH_WORKGRID);

export const getWorklistDataByIdRequest = createAction(actionTypes.GET_WORKLIST_DATA_BY_ID_REQUEST);
export const getWorklistDataByIdSuccess = createAction(actionTypes.GET_WORKLIST_DATA_BY_ID_SUCCESS);
export const getWorklistDataByIdFailure = createAction(actionTypes.GET_WORKLIST_DATA_BY_ID_FAILURE);

export const triggerRowHighlight = createAction(actionTypes.TRIGGER_ROW_HIGHLIGHT);

export const resetError = createAction(actionTypes.RESET_ERROR);

export const resetAllAdditionalFilterParams = createAction(
  actionTypes.RESET_ALL_ADDITIONAL_FILTER_PARAMS,
);
